var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"steps-six"},[(_vm.applyStatus === -2)?_c('DetailInfo',{on:{"success":function($event){_vm.auditInfo = $event}}}):_c('AuditTimeline',{attrs:{"data":_vm.auditInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }